import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/landing';
const OFFER_DURATION_SECONDS = 15 * 60;
export function Hero() {
  const [secondsLeft, setSecondsLeft] = useState(OFFER_DURATION_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft(current => Math.max(current - 1, 0));
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
  const seconds = (secondsLeft % 60).toString().padStart(2, '0');
  return <section className="relative w-full overflow-hidden bg-neutral-950 pt-9 text-white sm:pt-10" data-id="element-96" data-mp="ncgiiawhchrm">
      {/* Barra de urgencia fija durante todo el recorrido */}
      <div className="fixed inset-x-0 top-0 z-[60] flex min-h-9 items-center justify-center bg-red-600 px-3 py-1.5 text-center text-[10px] font-bold uppercase tracking-wide text-white shadow-md sm:min-h-10 sm:text-sm" data-id="element-97" data-mp="3czfkfwx3o34z">
        <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5" data-id="element-98" data-mp="3o7lrboupx2nw">
          <span data-id="element-99" data-mp="3o59efq3thihp">🔥 Oferta finaliza en</span>
          <span aria-live="polite" className="rounded bg-neutral-950 px-2 py-0.5 font-black tabular-nums text-yellow-300" data-id="element-100" data-mp="39b4l1c1dye87">
            {minutes}:{seconds}
          </span>
          <span data-id="element-101" data-mp="30iaziwvciilw">· 63% OFF</span>
        </span>
      </div>

      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-10 sm:px-6 lg:grid-cols-2 lg:items-center lg:py-16" data-id="element-102" data-mp="30gq4z7916zo1">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="order-2 lg:order-1" data-id="element-103" data-mp="35aue9x5rrjsa">
          <div className="mb-4 flex items-center gap-2" data-id="element-104" data-mp="2vglmxcsh5wvp">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-neutral-900" data-id="element-105" data-mp="2hkgibvk2d0sf">
              <FlameIcon className="h-3.5 w-3.5" data-id="element-106" data-mp="2lmld4xm903gn" /> Air Fryer Argentina
            </span>
            <div className="flex items-center gap-1 text-yellow-400" data-id="element-107" data-mp="s44e5chl11cm">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-108" data-mp="ibowkga76es9" data-mpi={i} />)}
              <span className="ml-1 text-xs text-neutral-300" data-id="element-109" data-mp="i9vu7d6magq2">+12.400 familias</span>
            </div>
          </div>

          <h1 className="text-3xl font-black leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-110" data-mp="1b0nizplcs33d">
            Cómo comer como en un{' '}
            <span className="text-yellow-400" data-id="element-111" data-mp="16342sk53hg8s">bodegón todos los días</span>, gastando
            la mitad en el súper y sin lavar una sola olla.
          </h1>

          <p className="mt-5 text-base text-neutral-300 sm:text-lg" data-id="element-112" data-mp="x1nuqj1r5q7q">
            El MegaPack definitivo de{' '}
            <span className="font-bold text-white" data-id="element-113" data-mp="3lt756pxsnptq">250 recetas</span> diseñado para el
            bolsillo y la realidad argentina. Dominá tu Air Fryer de una vez por todas.
          </p>

          <div className="mt-8" data-id="element-114" data-mp="1x9umefegzlpj">
            <CtaButton data-id="element-115" data-mp="1xama741tsf59" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="order-1 lg:order-2" data-id="element-116" data-mp="21aej5hv4snb5">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina: 4 tomos de recetas y 5 bonos" className="mx-auto w-full max-w-lg drop-shadow-2xl" data-id="element-117" data-mp="2b1hj2gcbqw8u" />
        </motion.div>
      </div>

      {/* Imagen realista de comida (gancho -> deseo) */}
      <div className="relative w-full" data-id="element-118" data-mp="2p0qnkir641wz">
        <img src={IMAGES.heroFood} alt="Plato abundante estilo bodegón argentino cocinado en Air Fryer" className="h-56 w-full object-cover sm:h-80 lg:h-96" data-id="element-119" data-mp="2p1scnr50qoxp" />
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-neutral-950 via-neutral-950/30 to-transparent" data-id="element-120" data-mp="umpp3yzj5gxf">
          <p className="mx-auto max-w-3xl px-4 pb-6 text-center text-lg font-bold text-white sm:text-2xl" data-id="element-121" data-mp="zmluo2nvlgf3">
            Milanesas crocantes, pollo dorado y empanadas de bodegón… sin freidora de
            aceite y sin ensuciar la cocina.
          </p>
        </div>
      </div>
    </section>;
}